import { render, staticRenderFns } from "./FixedIncome.vue?vue&type=template&id=b3fd1204&scoped=true"
import script from "./FixedIncome.vue?vue&type=script&lang=js"
export * from "./FixedIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd1204",
  null
  
)

export default component.exports